import * as React from "react"

type ResultItem = {
  label: string
  value: string
  hint?: string
}

type CalculatorResultProps = {
  title?: string
  items: ResultItem[]
  note?: string
}

export function CalculatorResult({
  title = "Результат",
  items,
  note,
}: CalculatorResultProps) {
  return (
    <section className="rounded-[1.75rem] border border-emerald-200 bg-gradient-to-br from-white to-emerald-50/80 p-5">
      <h2 className="mb-4 text-lg font-semibold text-neutral-950">{title}</h2>

      <dl className="space-y-3">
        {items.map((item) => (
          <div
            key={item.label}
            className="rounded-[1.25rem] border border-white/80 bg-white/90 px-4 py-3"
          >
            <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
              <div className="pr-4">
                <dt className="text-sm font-medium text-neutral-700">
                  {item.label}
                </dt>

                {item.hint ? (
                  <dd className="text-xs leading-6 text-neutral-500">
                    {item.hint}
                  </dd>
                ) : null}
              </div>

              <dd className="text-sm font-semibold text-emerald-800 sm:text-right">
                {item.value}
              </dd>
            </div>
          </div>
        ))}
      </dl>

      {note ? (
        <p className="mt-4 text-xs leading-6 text-neutral-600">{note}</p>
      ) : null}
    </section>
  )
}